import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import CvaService from '../services/CvaService';
import { Dropdown } from 'primereact/dropdown';
import { itemPerPage } from '../baseUrls/consts';

const DisponibiliteChauffeur = () => {
    const [items, setItems] = useState([]);
    const [globalFilter, setGlobalFilter] = useState('DISPONIBLE');
    const [loading, setLoading] = useState(true);

    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(itemPerPage);

    const onPageChange = (event) => {
        setFirst(event.first);
        setRows(event.rows);
    };

    useEffect(() => {
        loadItems();
    }, []);

    const loadItems = () => {
        CvaService.getDisponibliteActuelle((data, status) => {
                setLoading(false);
                if(status) setItems(data);   
            },
            {status: globalFilter}
        );
    }

    const choice = [
        {label: 'DISPONIBLE', value: 'DISPONIBLE'},
        {label: 'EN MISSION', value: 'EN_MISSION'}
    ]
   
    return (
        <>
            <h5>Disponibilité des chauffeurs</h5>
            <Toolbar className="mb-4" 
                left={
                    <React.Fragment>
                        <span className="block mt-6 md:mt-0 p-input-icon-left mr-2">
                            <Dropdown value={globalFilter} options={choice} optionLabel="label"
                                onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Sélectionner" />
                        </span>
                        <Button label="Actualiser" icon="pi pi-refresh" className="p-button-primry mr-2" 
                            onClick={()=>{setLoading(true); loadItems()}} />
                    </React.Fragment>
                }  />
                
                
            <DataTable dataKey="id" value={items} 
                paginator rows={itemPerPage} /*first={first}  
                totalRecords={120} rowsPerPageOptions={[5, 10, 20, 30]} onPageChange={onPageChange}  */
                loading={loading} /*globalFilter={globalFilter} */
                responsiveLayout="scroll" emptyMessage="Aucune donnée disponible.">

                <Column field="id" header="Identifiant" hidden sortable  />
                <Column field="matricule" header="Matricule" sortable  />
                <Column header="Nom" sortable style={{fontWeight: 'bold'}} body={(item)=> item.nom + " " + item.prenom}/>
                <Column field="telephone" header="Téléphone" sortable /> 
                <Column field="numeroPermis" header="Numéro permis" sortable />
                <Column field="institution.libelle" header="Institution" sortable />
                <Column field="etatChauffeur" header="Etat chauffeur" sortable body={ (item)=> 
                    <span className={`customer-badge status-${item.etatChauffeur === 'EN_SERVICE'? 'qualified' : 'unqualified'}`}>
                        {item.etatChauffeur}
                    </span>
                } />        
            </DataTable>
        </>
    );
}


export default DisponibiliteChauffeur;